import { defineStore } from "pinia"
import { computed, ref } from "vue"
import type { components } from "@/assets/api/openapi"

export const useOperationAdditionalDataAhStore = defineStore(
  "operationAdditionalDataAh",
  () => {
    const data = ref<components["schemas"]["OperationAdditionalDataAh"]>()
    const currentOperationId = ref<string>()
    const { startLoading, stopLoading, isLoading } = useLoading()

    const hasDataForOperation = computed(
      () => (operationId: string) =>
        data.value && currentOperationId.value === operationId
    )

    const fetchIfNeeded = async (operationId: string, force?: boolean) => {
      if (hasDataForOperation.value(operationId) && !force) {
        return data.value
      }
      return await fetchData(operationId)
    }

    const fetchData = async (operationId: string) => {
      startLoading()

      try {
        const { getOperationAdditionalDataAhByOperationId } = useAppApi()

        const response =
          await getOperationAdditionalDataAhByOperationId(operationId)

        data.value = response.data
        currentOperationId.value = operationId

        return data.value
      } catch {
        showError({
          statusCode: 500,
        })
      } finally {
        stopLoading()
      }
    }

    const clearData = () => {
      data.value = undefined
      currentOperationId.value = undefined
    }

    return {
      data: readonly(data),
      currentOperationId: readonly(currentOperationId),
      loading: readonly(isLoading),

      hasDataForOperation,
      fetchIfNeeded,
      fetchData,
      clearData,
    }
  }
)
